import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './set_divly_label.component.html'
})
export class SetDivlyLabelModalComponent extends BaseSupportModalComponent {
	siteId: string;
	action: string;

	async ok() {
		if (confirm(`Вы уверены, что хотите ${this.action == 'set' ? 'установить' : 'снять'} Divly-метку сайту: ${this.title}?`)) {

			await this.supportService.setDivlyLabel(this.siteId, this.action, this.comment).toPromise();

			this.execute();
		}
	}
}
